"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const checkForExternalLink = link => {
  return link && (link.startsWith("https") || link.startsWith("www"));
};
var _default = checkForExternalLink;
exports.default = _default;